<!--  -->
<template>
  <div class="adList-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-select
        v-model.number="params.position"
        size="small"
        placeholder="广告位置"
        clearable
        @change="getAdList()"
      >
        <el-option
          v-for="item in positionList"
          :value="item.value"
          :label="item.label"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-select
        v-model.number="params.adsType"
        size="small"
        placeholder="广告类型"
        clearable
        @change="getAdList()"
      >
        <el-option
          v-for="item in adsTypeList"
          :value="item.value"
          :label="item.label"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-input
        placeholder="请输入广告ID"
        size="small"
        clearable
        class="param-input"
        v-model="params.id"
        @change="getAdList()"
      ></el-input>
      <!-- <el-input placeholder="请输入商区码" size="small" clearable class="param-input" v-model="params.discCode"  @change="getAdList()"></el-input>       -->
      <el-button type="primary" size="small" @click="getAdList()">搜索</el-button>
      <el-button type="primary" size="small" @click="addAds('add')">新增</el-button>
    </div>
    <!--表格数据-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      ref="multipleTable"
      height="620"
    >
      <el-table-column prop="adsType" label="广告类型" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{scope.row.adsType?'商区广告':'系统广告'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="cover" label="广告封面图" align="center" width="120">
        <template slot-scope="scope">
          <img-load
            :src="imgUrl + scope.row.cover"
            :width="'90px'"
            :height="scope.row.position===0?'195px':(scope.row.position===1?'81.3px':(scope.row.position===2?'178.4px':(scope.row.position===3?'32.5px':(scope.row.position===4?'62.5px':'15px'))))"
          />
          <p>{{scope.row.width+'x'+scope.row.height}}</p>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="广告标题" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="href" label="链接地址" align="center" width="150px">
        <template slot-scope="scope">
          <span>{{ scope.row.href }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="position" label="广告位置" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.position | positionFun }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="hrefType" label="广告链接类型" align="center" width="150px">
        <template slot-scope="scope">
          <span>{{ scope.row.hrefType | hrefTypeFun  }}</span>
        </template>
      </el-table-column>-->
      <el-table-column prop="sortCode" label="排序号" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.sortCode }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="districtCode" label="商区码" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.districtCode  }}</span>
        </template>
      </el-table-column>-->
      <!-- <el-table-column prop="remark" label="备注" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.remark  }}</span>
        </template>
      </el-table-column>-->
      <el-table-column prop="id" label="广告ID" align="center" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="reviewID" label="审核ID" align="center" width="150px">
        <template slot-scope="scope">
          <span>{{ scope.row.adID=scope.row.reviewID==='000000000000000000000000'?'未知':scope.row.reviewID}}</span>
        </template>
      </el-table-column>-->
      <el-table-column prop="createdAt" label="创建时间" align="center" width="160px">
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | changeDate }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="receiptInfo" label="审核信息" align="center" width="150px">
        <template slot-scope="scope">
          <span>{{ scope.row.receiptInfo  }}</span>
        </template>
      </el-table-column>-->
      <el-table-column prop="start" label="开始时间" align="center" width="160px">
        <template slot-scope="scope">
          <span>{{ scope.row.start | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="end" label="结束时间" align="center" width="160px">
        <template slot-scope="scope">
          <span>{{ scope.row.end | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="active" label="激活" align="center">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.active" disabled></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="click" label="点击次数" align="center" min-width="80" fixed="right">
        <template slot-scope="scope">
          <span>{{ scope.row.click }}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" fixed="right" align="center" width="150">
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            icon="el-icon-edit"
            @click="addAds('edit',scope.row)"
          ></el-button>
          <el-button type="danger" size="mini" icon="el-icon-delete" @click="remove(scope.row.id)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-sizes="[5, 10, 20, 30]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 5"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!--新增、编辑申请广告弹窗-->
    <add-page ref="addPage" @handlerAgentList="handlerAgentList"></add-page>
  </div>
</template>
<script>
import addPage from "./components/addPage";
import api from "@/api";
import baseConfig from "@/utils/serverUrlConfig";
export default {
  data() {
    return {
      disabled: false,
      tableData: [],
      loading: false,
      total: 0,
      type: "",
      imgUrl: baseConfig.imgUrl,
      params: {
        pageNumber: 1,
        pageSize: 10,
        adsType: 0,
        // status:'',
        discCode: "",
        id: ""
      },
      adsTypeList: [
        { label: "系统广告", value: 0 },
        { label: "商区广告", value: 1 }
      ],
      positionList: [
        { label: "启动页广告", value: 0 },
        { label: "首页-推荐小广告", value: 1 },
        { label: "首页-弹窗公告", value: 2 },
        { label: "消息-界面广告", value: 3 },
        { label: "撩吧-轮播广告", value: 4 },
        { label: "钱包-轮播广告", value: 5 },
        { label: "搜索-轮播广告", value: 6 },
        { label: "AV解说-轮播广告", value: 7 },
      ]
    };
  },
  created() {
    this.getAdList();
  },
  components: {
    addPage
  },
  methods: {
    getAdList(type) {
      if (type === "status") {
        this.annouParam.pageNumber = 1;
      }
      this.loading = true;
      api.getAdList(this.params).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.list;
          this.total = res.data.total;
          this.discCode = res.data.list.districtCode;
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.loading = false;
      });
    },
    handlerAgentList() {
      this.getAdList();
    },
    // 分页条数改变回掉
    changeSize(size) {
      this.params.pageSize = size;
      this.getAdList();
    },
    // 分页页码改变回掉
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getAdList();
    },
    // 新增、修改
    addAds(type, data) {  
      this.$refs.addPage.open(type, data);
        
    },
    //删除
    remove(id) {
      this.$confirm("您确定要删除该条广告吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        api.delAds({ id: id }).then(res => {
          if (res.code === 200) {
            this.getAdList();
            this.$message({
              message: "删除成功",
              type: "success"
            });
          } else {
            this.$message.error("删除失败！");
          }
        });
      });
    }
  }
};
</script>
<style scoped lang="scss">
</style>
